module.exports = __webpack_public_path__ + "img/svg - middle boy.e1f76dae.svg";